import { Injectable } from "@angular/core";
import {
    BaseNotificationEventsService,
    DssNotification,
    DssNotificationsService,
    DssRestrictionApplicationNotificationType,
} from "@dtm-frontend/dss-shared-lib";
import { Notification, NotificationDisplay, SharedNotificationDisplayProps } from "@dtm-frontend/shared/notifications";
import { IconName } from "@dtm-frontend/shared/ui";
import { FunctionUtils } from "@dtm-frontend/shared/utils";
import { TranslocoService } from "@jsverse/transloco";

@Injectable({
    providedIn: "root",
})
export class AnspApplicationNotificationEventsService implements BaseNotificationEventsService {
    constructor(private readonly translocoService: TranslocoService, private readonly dssNotificationsService: DssNotificationsService) {}

    public getEventsList(notificationsToFormat: DssNotification[]): NotificationDisplay[] {
        return notificationsToFormat
            .filter((notification) =>
                this.dssNotificationsService
                    .getDssRestrictionApplicationNotificationTypes()
                    .some((type) => notification.payload.type === type)
            )
            .map((notification) => {
                const sharedProps = this.getSharedProps(notification, "file-text");

                switch (notification.payload.type) {
                    case DssRestrictionApplicationNotificationType.AutomaticallyPublishedEvent:
                        return this.getAutomaticallyPublishedEvent(sharedProps, notification);

                    case DssRestrictionApplicationNotificationType.AnspAcceptedRestrictionApplicationEvent:
                        return this.getAnspAcceptedRestrictionApplicationEvent(sharedProps, notification);

                    case DssRestrictionApplicationNotificationType.InstitutionReAcceptedEvent:
                        return this.getInstitutionReAcceptedEvent(sharedProps, notification);

                    default:
                        return null;
                }
            })
            .filter(FunctionUtils.isTruthy);
    }

    private getAutomaticallyPublishedEvent(
        sharedProps: SharedNotificationDisplayProps,
        notification: DssNotification
    ): NotificationDisplay {
        return {
            ...sharedProps,
            title: this.translocoService.translate("dssAdmin.notifications.restrictionApplicationLabel"),
            text: this.translocoService.translate("dssAdmin.notifications.automaticallyPublishedText"),
            redirectUrl: `flight-zone/preview/${notification.payload.id}`,
        };
    }

    private getAnspAcceptedRestrictionApplicationEvent(
        sharedProps: SharedNotificationDisplayProps,
        notification: DssNotification
    ): NotificationDisplay {
        return {
            ...sharedProps,
            title: this.translocoService.translate("dssAdmin.notifications.restrictionApplicationLabel"),
            text: this.translocoService.translate("dssAdmin.notifications.anspAcceptedRestrictionApplicationText"),
            redirectUrl: `flight-zone/preview/${notification.payload.id}`,
        };
    }

    private getInstitutionReAcceptedEvent(sharedProps: SharedNotificationDisplayProps, notification: DssNotification): NotificationDisplay {
        return {
            ...sharedProps,
            title: this.translocoService.translate("dssAdmin.notifications.restrictionApplicationLabel"),
            text: this.translocoService.translate("dssAdmin.notifications.applicationReAcceptedText"),
            redirectUrl: `flight-zone/${notification.payload.id}`,
        };
    }

    private getSharedProps(notification: Notification, icon: IconName): SharedNotificationDisplayProps {
        return { icon, date: notification.createdAt, id: notification.id, isRead: notification.read };
    }
}
